// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

// Services
import { authService, timesheetApi, msGraphApi } from './services/ServiceInst.js'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import './registerServiceWorker'

// Sync store with router
sync(store, router)

Vue.config.productionTip = false

// services will be available to be used from any component
// e.g. this.$timesheetApi or this.$authService
Vue.prototype.$authService = authService
Vue.prototype.$timesheetApi = timesheetApi
Vue.prototype.$msGraphApi = msGraphApi

/* eslint-disable no-new */
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')